// extracted by mini-css-extract-plugin
export default {"customSearchbar":"Searchbar_customSearchbar__TOuhG"};